var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompacticonBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Compact_icon_-_black",
    "data-name": "Compact icon - black",
    transform: "translate(-373 -56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2947",
    "data-name": "Rectangle 2947",
    transform: "translate(373 56)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-dashboard-1948130",
    transform: "translate(286.678 39.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12433",
    "data-name": "Path 12433",
    d: "M91.617,17.5H88.088a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588V18.088A.588.588,0,0,0,91.617,17.5Zm-.588,3.529H88.676V18.676h2.352Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12434",
    "data-name": "Path 12434",
    d: "M284.117,17.5h-3.529a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588V18.088A.588.588,0,0,0,284.117,17.5Zm-.588,3.529h-2.352V18.676h2.352Z",
    transform: "translate(-186.031 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12435",
    "data-name": "Path 12435",
    d: "M476.617,17.5h-3.529a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588V18.088A.588.588,0,0,0,476.617,17.5Zm-.588,3.529h-2.352V18.676h2.352Z",
    transform: "translate(-372.062 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12436",
    "data-name": "Path 12436",
    d: "M91.617,210H88.088a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588v-3.529A.588.588,0,0,0,91.617,210Zm-.588,3.529H88.676v-2.352h2.352Z",
    transform: "translate(0 -186.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12437",
    "data-name": "Path 12437",
    d: "M284.117,210h-3.529a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588v-3.529A.588.588,0,0,0,284.117,210Zm-.588,3.529h-2.352v-2.352h2.352Z",
    transform: "translate(-186.031 -186.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12438",
    "data-name": "Path 12438",
    d: "M476.617,210h-3.529a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588v-3.529A.588.588,0,0,0,476.617,210Zm-.588,3.529h-2.352v-2.352h2.352Z",
    transform: "translate(-372.062 -186.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12439",
    "data-name": "Path 12439",
    d: "M91.617,402.5H88.088a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588v-3.529A.588.588,0,0,0,91.617,402.5Zm-.588,3.529H88.676v-2.352h2.352Z",
    transform: "translate(0 -372.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12440",
    "data-name": "Path 12440",
    d: "M284.117,402.5h-3.529a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588v-3.529A.588.588,0,0,0,284.117,402.5Zm-.588,3.529h-2.352v-2.352h2.352Z",
    transform: "translate(-186.031 -372.062)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12441",
    "data-name": "Path 12441",
    d: "M476.617,402.5h-3.529a.588.588,0,0,0-.588.588v3.529a.588.588,0,0,0,.588.588h3.529a.588.588,0,0,0,.588-.588v-3.529A.588.588,0,0,0,476.617,402.5Zm-.588,3.529h-2.352v-2.352h2.352Z",
    transform: "translate(-372.062 -372.062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompacticonBlack);
export default __webpack_public_path__ + "static/media/Compact icon - black.ed94e4a92fc077fad1ff5c63081b98d0.svg";
export { ForwardRef as ReactComponent };